import type { IReportStoragePort } from '@reports/application/ports';

/**
 * Use case to clear applied filters and metadata from storage
 *
 * Clears both filters and metadata to maintain consistency.
 * When filters are cleared, metadata should also be cleared.
 *
 * @param storagePort - Storage port implementation
 * @returns Use case with execute method
 */
export const clearAppliedFiltersUseCase = (storagePort: IReportStoragePort) => {
  const execute = async (): Promise<void> => {
    await storagePort.clearAppliedFilters();
    await storagePort.clearFiltersMetadata();
  };

  return { execute };
};
